import { Event, utils } from '@coral-xyz/anchor';
import { VersionedTransactionResponse } from '@solana/web3.js';
import { JUPITER_PROGRAM } from '../program';

export function getEvents(transactionResponse: VersionedTransactionResponse) {
  let events: Event[] = [];

  if (transactionResponse && transactionResponse.meta) {
    let { meta } = transactionResponse;

    meta.innerInstructions?.map(async (ix) => {
      ix.instructions.map(async (iix) => {
        const ixData = utils.bytes.bs58.decode(iix.data);
        const eventData = utils.bytes.base64.encode(ixData.subarray(8));
        const event = JUPITER_PROGRAM.coder.events.decode(eventData);

        if (!event) return;

        events.push(event);
      });
    });
  }

  return events;
}
